import moment from "moment";
import React, { useState, useEffect } from "react";
import axiosInstance from "../../axios";
import { Loading } from "../Other/Loading";

const StudentUpcomingWebinar = () => {
  const [getUpcomingWebinar, setGetUpcomingWebinar] = useState();
  const [dataIndex, setDataIndex] = useState(5);
  const [fetchData, setFetchData] = useState(true);

  useEffect(() => {
    axiosInstance
      .get("/webinar/upcomming")
      .then((res) => {
        setGetUpcomingWebinar(res?.data?.data);
        setFetchData(false);
      })
      .catch((error) => {
        console.log(error);
        setFetchData(false);
      });
  }, []);

  return (
    <>
      <div className="flex-chart-40">
        <div className="margin-top-new-01">
          <div className="box-shadow-new-01">
            <p className="paragraph-css">Upcoming webinar</p>
            {fetchData && (
              <div className="admindata-loading">
                <Loading />
              </div>
            )}
            {getUpcomingWebinar && getUpcomingWebinar.length !== 0 && (
              <table id="customers" className="studentfetchData">
                <thead>
                  <tr>
                    <th className="fs-10">Webinar Name</th>
                    <th className="fs-10">Date</th>
                    <th className="fs-10">Time</th>
                  </tr>
                </thead>
                <tbody>
                  {getUpcomingWebinar &&
                    getUpcomingWebinar.length > 0 &&
                    getUpcomingWebinar.slice(0, dataIndex).map((ele, index) => (
                      <tr key={index}>
                        <td>{ele.eventName}</td>
                        <td>{moment(ele?.webinarDate).format("DD-MM-YYYY")}</td>
                        <td>{ele.startTime}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            )}
            {getUpcomingWebinar && getUpcomingWebinar.length === 0 && (
              <span>Upcoming webinar not found</span>
            )}
            {getUpcomingWebinar && getUpcomingWebinar.length > 5 && (
              <div
                className="studentViewAllRecords"
                onClick={() =>
                  setDataIndex(getUpcomingWebinar && getUpcomingWebinar.length)
                }
              >
                View All
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default StudentUpcomingWebinar;
